<template>
  <div>
    <v-field>
      <label for="accountIds">Pripada računom</label>
      <r-searchable-select v-model="form.accountIds" :options="accounts.map(a => ({ value: a.id, label: a.name }))" />
    </v-field>

    <v-checkbox v-model="form.isAccountAdmin">Je administrator računov</v-checkbox>
  </div>
</template>

<script>
import ValidationMixin from '@/components/shared/ValidationMixin'
import AutocompleteFixMixin from '@/components/shared/AutocompleteFixMixin'
import VCheckbox from 'design-system/VCheckbox'
import VField from 'design-system/VField.vue'
import RSearchableSelect from 'design-system/components/RSearchableSelect.vue'

export default {
  components: {
    VCheckbox,
    VField,
    RSearchableSelect,
  },
  data () {
    return {
      form: {
        accountIds: [],
        isAccountAdmin: false,
      },
    }
  },
  props: {
    user: { type: Object, required: true },
    accounts: { type: Array, required: true },
  },
  mixins: [ValidationMixin, AutocompleteFixMixin],
  created () {
    if (!this.user) {
      return
    }
    if (this.form.accountIds.length === 0) {
      this.form.accountIds = this.user.accounts.map(a => a.id)
    }
    // for now we'll only allow setting isAccountAdmin
    // for all or for none of the accounts the user is member of
    this.form.isAccountAdmin = this.user.accountMemberships.some(a => a.isAccountAdmin)
  },
  watch: {
    form: {
      handler (newFormValue) {
        this.$emit('change', {
          ...this.user,
          ...newFormValue,
        })
      },
      deep: true,
    },
  },
  methods: {
    runAllValidations () {
      this.$v.$touch()
    },
    isValid () {
      return !this.$v.$invalid
    },
  },
  validations: {},
}
</script>

<style lang="scss" scoped>
</style>
